<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<style lang="scss">
#app {
  font-family: '微软雅黑';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: unset;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>
export default {
  name: 'home',
  components: {

  },
  data () {
    return { }
  },
  mounted () {},
  created () {

  },
  methods: {}
}
</script>
